<template>
  <div class="ccui-home-index">
    <div class="ccui-navigation mb15">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack()"
        >{{ $t("page.menuList.back") }}</el-button
      >
      <div class="ccui-navigation-divider" />
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/' }">{{
          $t("page.menuList.electronicBidding")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/myProject/myProject' }">{{
          $t("page.menuList.MyProjects")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t("page.content.View") }}
          <span class="ccui-curr-crumb ccui-ml-10">
            {{ $t("page.content.myToDo") }}</span
          >
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container dic-diy-app-container">
      <div class="mb20">
        <anchorTitle
          isList
          :tabBtn="tableTopBtn"
          :isShowNum="false"
          :isFocus="isFocus"
        />
      </div>
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :showOpObj="showOpObj"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="[]"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleRowClick="handleRowClick"
          @changeTableTitleWidth="changeTableTitleWidth"
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
          :emptyText="emptyText"
        >
          <!--列表中的插槽Begin-->
          <template slot="schemeName" slot-scope="{ row }">
            <el-button
              size="mini"
              class="taskCodeBtn"
              type="text"
              @click="toBid(row)"
              >{{ row.schemeName }}</el-button
            >
          </template>
          <template slot="schemeStatusName" slot-scope="{ row }">
            {{
               row.schemeStatusName == "执行中"
                  ? $t("page.content.performing")
                  : row.schemeStatusName == "已完成"
                  ? $t("page.content.completed") :
                  row.schemeStatusName == "已流标"
                  ? $t("page.content.droppedMarkStatus") 
                  : ""
              }}
          </template>
          <!--列表中的插槽End-->
          <!--批量操作-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import {
  queryBidBiddingListOfPurchase,
  queryPendingBidListOfPurchase,
  queryPendingSupplementListOfPurchase,
  queryPendingPrequalificationListOfPurchase,
  queryPendingAnswerQuestionsListOfPurchase,
  queryPendingNegotiationListOfPurchase,
  queryPendingQuotationListOfPurchase,
  queryPendingBidEvaluationClarificationListOfPurchase,
  queryPendingSellingBidListOfPurchase
} from "@/app/myProjects/api/myProjects.js";
export default {
  name: "myToDo",
  components: {},
  created() {
    this.getSupplierList(); // 必须在created里面
  },
  mounted() {},
  data() {
    return {
      tableName: "myToDoitemsList", // 默认的tableName 工程中唯一
      isSelection: false,
      showOpObj: {
        showOpSetting: false, // 是否高级设置
        width: 0 // 操作宽度
      },
      formData: {
        schemeName: ""
      },
      tableTopBtn: [{ label: this.$route_query.value, value: "1" }], //全部
      isFocus: "1",
      tableData: [],
      fixedTableThead: [],
      unfixedTableThead: [
        {
          label: this.$t("page.content.No"), //序号
          type: "index",
          width: 55,
          fixed: true
        },
        {
          label: this.$t("page.content.ProjectNo"),
          prop: "schemeCode",
          minWidth: 130
        }, //项目编号
        {
          label: this.$t("page.content.ProjectName"), //项目名称
          prop: "schemeName",
          minWidth: 300,
          slot: "schemeName"
        },
        {
          label: this.$t("page.content.Status"),
          prop: "schemeStatusName",
          width: 80,
          slot: "schemeStatusName"
        } //状态
      ],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      emptyText: ""
    };
  },
  methods: {
    tableTopChange({ value }) {
      // 按钮切换
      // 初始化
      this.isFocus = value;
    },
    handleList() {
      // 分页操作列表
      this.getSupplierList();
    },
    getSupplierList() {
      let type = this.$route_query.type;

      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supCode: this.$route_query.supCode,
        queryPendingNoticeListReqBO: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          supCode: this.$route_query.subcontractorCode
        }
      };
      //后续接口没判断
      let url = "";
      if (type == 1) {
        //补遗
        url = queryPendingSupplementListOfPurchase;
      } else if (type == 5) {
        //竞价中
        url = queryBidBiddingListOfPurchase;
      } else if (type == 6) {
        //投标
        url = queryPendingBidListOfPurchase;
      } else if (type == 3) {
        // 资格预审
        url = queryPendingPrequalificationListOfPurchase;
      } else if (type == 4) {
        // 答疑
        url = queryPendingAnswerQuestionsListOfPurchase;
      } else if (type == 0) {
        // 谈判中
        url = queryPendingNegotiationListOfPurchase;
      } else if (type == 2) {
        //报价中
        url = queryPendingQuotationListOfPurchase;
      } else if (type == 7) {
        //澄清
        url = queryPendingBidEvaluationClarificationListOfPurchase;
      } else if (type == 8) {
        //售标
        url = queryPendingSellingBidListOfPurchase;
      }
      Object.assign(param, { agentId: this.$router.history.current.query.a });
      url(param).then(res => {
        this.emptyText = this.$t("page.content.noData");
        if (res) {
          this.tableData = res.data.data.rows;
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    toBid(row) {
      console.log(row, "name");
      //note 我的待办 点击项目名称跳转
      this.$store.commit("editRouterName", row.label);
      sessionStorage.setItem("purchaseType", row.purchaseType);
      sessionStorage.setItem("schemeId", row.schemeId); //防止有些页面使用session取schemeId 下面的query最好也不要删除
      sessionStorage.setItem("supCode", row.supCode);
      sessionStorage.setItem("supName", row.supName);
      // 头部信息
      let schemeObj = {
        schemeName: row.schemeName ? row.schemeName : "",
        schemeCode: row.schemeCode ? row.schemeCode : "",
        exeBeginTime: row.noticeStartTime ? row.noticeStartTime : "",
        exeEndTime: row.noticeEndTime ? row.noticeEndTime : ""
      };
      sessionStorage.setItem("schemeObj", JSON.stringify(schemeObj));
      this.$store.commit("editSchemeObj", schemeObj);
      console.log("row.routerName---", row.routerName);
      sessionStorage.setItem("supplierFlag", row.supplierFlag);
      this.$router.push({
        name: row.supplierFlag == 1 ? row.routerName : "bidFlowIndex",
        query: {
          schemeId: row.schemeId,
          purStep: row.menuKey,
          supProcessId: row.supProcessId,
          supplierFlag: row.supplierFlag
        }
      });
    },
    handleBack() {
      this.$router.back();
    },
    change(index, key, value) {
      const formDataKeys = Object.keys(this.formData);
      formDataKeys.map(_ => {
        if (_ !== key) this.formData[_] = "";
      });
    },
    changeTableTitleWidth() {
      // 改变头部宽度
    },
    handleRowClick(row, column, event) {
      // 行点击事件
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.taskCodeBtn {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
}
.dic-diy-app-container {
  min-height: calc(100vh - 235px) !important;
}
</style>
